module.exports = __webpack_public_path__ + "img/bg.47adeead.jpg";